import { css } from 'styled-components';
import TrackedButton from '../TrackedButton';
import { ICON_ONLY_NAV_DELAY_MS, PIN_BUTTON_ITEM_ID, PinButtonActions } from './constants';
import { useCallback, useRef } from 'react';
import { useTranslation } from '../../hooks/useNavConfig';
import { ExpandCollapseIcon } from 'breadcrumbs-ui/icons';
import useNavItems from '../../hooks/useNavItems';
import { useAppDispatch } from '../../hooks';
import { togglePrimaryNavTooltip } from '../../reducers/navItems';
import VerticalNavMenuItemTooltip from './VerticalNavMenuItemTooltip';
import debounce from 'hs-lodash/debounce';
import styledWithSpecialtyTheme from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButton = styledWithSpecialtyTheme(TrackedButton)(({
  theme
}) => {
  return css(["background:transparent;border:0;height:", ";width:", ";display:flex;justify-content:center;align-items:center;border-radius:6px;:hover{background:", ";& > svg{fill:", ";}}"], theme.space['1000'], theme.space['1000'], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-icon-nav-item-hover']);
});
export const PinButton = ({
  isPinned,
  setIsPinned,
  tempPauseOutsideAlerter
}) => {
  const {
    primaryNav: {
      openTooltip
    }
  } = useNavItems();
  const dispatch = useAppDispatch();
  const ref = useRef(null);
  const showTooltip = useCallback(() => {
    dispatch(togglePrimaryNavTooltip({
      id: PIN_BUTTON_ITEM_ID
    }));
  }, [dispatch]);
  const delayedShowTooltip = debounce(showTooltip, ICON_ONLY_NAV_DELAY_MS);
  const closeTooltip = useCallback(() => {
    dispatch(togglePrimaryNavTooltip({
      id: undefined
    }));
  }, [dispatch]);
  const handlePinClick = useCallback(() => {
    requestAnimationFrame(() => {
      const nextPinnedState = !isPinned;
      setIsPinned(nextPinnedState);
      if (!nextPinnedState) {
        tempPauseOutsideAlerter();
      }
    });
  }, [isPinned, setIsPinned, tempPauseOutsideAlerter]);
  const {
    t
  } = useTranslation();
  const tooltipText = isPinned ? t('nav.pinButton.iconOnlyCollapseNav') : t('nav.pinButton.iconOnlyKeepOpen');
  const isTooltipOpen = openTooltip === PIN_BUTTON_ITEM_ID;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledButton, {
      ref: ref,
      "aria-hidden": "true",
      tabIndex: -1,
      onClick: handlePinClick,
      "data-test-id": `isPinned-${isPinned}`,
      "data-onboarding-hook": "expand-collapse",
      "data-click-action": isPinned ? PinButtonActions.collapse : PinButtonActions.expand,
      id: "hs-vertical-nav-expand-collapse",
      onMouseEnter: delayedShowTooltip,
      onMouseLeave: closeTooltip,
      onBlur: closeTooltip,
      children: /*#__PURE__*/_jsx(ExpandCollapseIcon, {
        isPinned: isPinned
      })
    }), isTooltipOpen ? /*#__PURE__*/_jsx(VerticalNavMenuItemTooltip, {
      label: tooltipText,
      buttonRef: ref
    }) : null]
  });
};
export default PinButton;